import { Component, OnChanges, Optional, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { ValidatorsUtils, MfpcMainComponent, FileBase64 } from 'base-form';
import { DialogService } from 'primeng/dynamicdialog';
import { ActivatedRoute } from '@angular/router';
import { LOCALE } from '../../constants/locale.const';
import { PrimeNGConfig } from 'primeng/api';
import {
  MfpcShowFileDialogComponent
} from '../mfpc-show-file-dialog/mfpc-show-file-dialog.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mfpc-prime',
  templateUrl: './mfpc-main.component.html',
  styleUrls: ['./mfpc-main.component.scss'],
})
export class MfpcPrimeComponent extends MfpcMainComponent implements OnChanges {
  constructor(
    protected fb: FormBuilder,
    protected validators: ValidatorsUtils,
    protected activatedRoute: ActivatedRoute,
    @Optional() protected dialogService: DialogService,
    private config: PrimeNGConfig,
  ) {
    super(
      fb,
      validators,
      activatedRoute
    );
    this.config.setTranslation(LOCALE[this.dateLocale]);
  }

  openFileDialog(fileBase64: string | FileBase64): void {
    this.dialogService.open(MfpcShowFileDialogComponent, {
      data: { fileBase64 },
      showHeader: false,
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes.dateLocale && changes.dateLocale.currentValue) {
      this.config.setTranslation(LOCALE[changes.dateLocale.currentValue]);
    }
  }

  removeSmartPrimeGroup(arg: {name: string, index: number}): void {
    const {name, index} = arg;
    const arrayControl: FormArray = this.form.get(name) as FormArray;
    arrayControl.controls.splice(index, 1);
  }
}
